import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pointer",style:({
            opacity: (_vm.loading)?0.5:1
          }),attrs:{"title":"Перезвонить клиенту"},on:{"click":_vm.onChange}},[_c('span',[_c(VIcon,{style:({
            'font-size': (_vm.isOk===0)?'14px':'20px',
            color: (_vm.isOk===0)?'gray':'gold',
            'border-radius': '50%',
            'border': '1px solid',
            'background-color': (_vm.isOk===0)?'transparent':'white',
            'border-color': (_vm.isOk===0)?'transparent':'red',
            'margin': '2px',
            'padding': '2px',
          })},[_vm._v("mdi-bell-ring-outline")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }